import React from "react";
import { Link } from "react-router-dom";

function Page404() {
  return (
    <div className="full-page grey-background-color">
     {/* <div className="full-page" style={{display:'flex',height:'100vh'}}> */}
      <section className="content">
        <div className="error-page">
          <h2 className="headline text-warning">404</h2>

          <div className="error-content">
            <h3>
              <i className="fas fa-exclamation-triangle text-warning"></i> Oops!
              Page not found.
            </h3>

            <p>
              We could not find the page you were looking for. Meanwhile, you
              may
              {/* <a href="">return to dashboard</a>  */}
              <Link to="/home"> return to dashboard </Link>
              or try using the search form.
            </p>
          </div>
          {/* /.error-content  */}
        </div>
      </section>
    </div>
 
  );
}

export default Page404;
